import React from 'react';
import './Status-style.css';

const Status = ({ value, map }) => {
    const fullMap = Object.assign(map, {
        4096: ['Cancelled', '#584487']
    });
    const [text, color] = fullMap[value] || ['Not Assigned', '#6a7276'];
    return (
        <span className="status" style={{ color }}>
            {text}
        </span>
    );
};
export default Status;
